import { Action } from '@ngrx/store';

export enum CoreContextActionTypes {
  SET_COOKIE_TRACKING_CONSENT = '[CoreContext] Set cookie tracking',
  SET_COOKIE_TRACKING_CONSENT_HANDLED = '[CoreContext] Set cookie tracking handled',
}

export class SetCookieTrackingConsent implements Action {
  public readonly type = CoreContextActionTypes.SET_COOKIE_TRACKING_CONSENT;

  constructor(public enabled: boolean, public updateMember = true) {}
}

export class SetCookieTrackingConsentHandled implements Action {
  public readonly type = CoreContextActionTypes.SET_COOKIE_TRACKING_CONSENT_HANDLED;
}
